import React from 'react'
import { useSelector } from 'react-redux'

import { greyMultibrandPalette } from '@masfront/common-b2c'

import { Typography, Box } from '@material-ui/core'
import SimCardIcon from '@material-ui/icons/SimCard'

import { selectTariffSidebarInformation } from './Sidebar.selectors'
import SidebarAccordion from './SidebarAccordion'
import SidebarMonthToMonth from './SidebarMonthToMonth'
import useStyles from './SidebarStyles'

import { RootState } from '~/core/store/root.reducer'

export interface SidebarPrice {
  duration: string
  amount: string
}

export interface SingleInfo {
  name?: string
  phoneNumber: string
  prices: SidebarPrice[]
  bundles: {
    name: string
    prices: SidebarPrice[]
  }[]
}

function SidebarSection({
  prices,
  children,
  isTariff,
  isBundle,
}: {
  prices: SidebarPrice[]
  children: React.ReactNode
  isTariff?: boolean
  isBundle?: boolean
}) {
  const { greyColor } = useStyles()
  const hasSinglePrice = prices.length === 1
  return (
    <Box width="100%">
      <Box mb={3} display="flex" justifyContent="space-between">
        {children}
        {hasSinglePrice &&
          prices.map(({ amount }) => (
            <Typography variant="body1" className={greyColor} key={`single-price-${amount}`}>
              <strong>{amount} </strong>
              €/mes
            </Typography>
          ))}
      </Box>
      {!hasSinglePrice &&
        prices.map(({ duration, amount }) => (
          <SidebarMonthToMonth
            isTariff={isTariff}
            isBundle={isBundle}
            duration={duration}
            amount={amount}
            key={`prices-sidebar-tariff-${amount}`}
          />
        ))}
    </Box>
  )
}

function SidebarTariffInfo({ id }: { id: string }) {
  const { icon, greyColor } = useStyles()

  const { name, prices, bundles, phoneNumber } = useSelector((state: RootState) =>
    selectTariffSidebarInformation(id)(state),
  )

  return name ? (
    <SidebarAccordion title={name} subtitle={phoneNumber} dataHook={`sidebar-tariff-${id}`}>
      <Box width="100%">
        <SidebarSection prices={prices} isTariff>
          <Box display="flex">
            <SimCardIcon className={icon} />
            <Typography variant="h6">TARIFA</Typography>
          </Box>
        </SidebarSection>
        {bundles.map(({ name, prices }) => (
          <SidebarSection prices={prices} isBundle key={`sidebar-section-${name}`}>
            <Typography variant="body2" component={Box} maxWidth="68%" className={greyColor}>
              {name}
            </Typography>
          </SidebarSection>
        ))}
      </Box>
    </SidebarAccordion>
  ) : (
    <Box
      className={greyColor}
      px={6}
      py={6}
      borderBottom={`1px solid ${greyMultibrandPalette[500]}`}
    >
      <Typography variant="subtitle2">Tarifa</Typography>
      <Box fontStyle="italic" mt={2}>
        <Typography variant="body2">No se ha seleccionado aún</Typography>
      </Box>
    </Box>
  )
}

export default SidebarTariffInfo
